import React from "react";
import { useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import popup2 from "../img/popup.png";
import popup_mobile2 from "../img/popup_mobile.png";
import popup_desktop from "../img/popup_desktop.jpg";
import pop_mobile from "../img/pop_mobile.jpg";

const Popup = () => {
  const [open, setOpen] = useState(true);

  return (
    // <div className={`${open ? "fixed" : "hidden" } w-screen h-screen overflow-x-hidden bg-black/70 z-[1000]`}>
    // <div className='absolute w-5/6 max-w-[480px] h-auto md:w-1/2 lg:w-[480px] bg-transparent top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 '>
    //    <IoCloseSharp size={40} className="absolute -right-5 lg:-right-14 -top-12 text-white cursor-pointer" onClick={() => setOpen(false)} />
    //    <img src="assets/images/popup.png" alt="popup_image" className='w-full h-full object-contain' />
    //    <a href='https://www.tbdine.com/book/restaurant/the-farmhouse-restaurant?idApp=70973&language=en-us' rel="noreferrer" target="_blank" className='absolute left-5 sm:left-8 lg:left-10 bottom-6 lg:bottom-10 tracking-widest text-sm lg:text-lg cursor-pointer font-primary lowercase bg-black text-white py-1 md:py-1.5 px-1.5 md:px-3 whitespace-nowrap transition-all hover:bg-th-red hover:text-white'>RESERVE NOW</a>
    // </div>
    // </div>
    <>
      <div
        className={`${
          open ? "fixed" : "md:hidden"
        } w-screen h-screen overflow-x-hidden bg-black/70 z-[1000] hidden md:inline-block`}
        onClick={() => setOpen(false)}
      ></div>
      <div
        className={`${
          open ? "absolute" : "md:hidden"
        } bg-transparent top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] xl:w-1/2 bg-[#EAE4DA] flex z-[1001]`}
      >
        <IoCloseSharp
          size={40}
          className="absolute -right-5 lg:-right-14 -top-12 text-white cursor-pointer hidden md:inline-block"
          onClick={() => setOpen(false)}
        />
        <div className="relative hidden md:inline-block px-4 mx-auto">
          {/* <img
            src={popup_desktop}
            alt="Father's Day brunch promotion popup for The Farmhouse featuring N'Duja and Fennel Sausage Hash and a Wildeye Pilsner pairing (desktop)"
            className="h-full object-contain"
          />
          <div className="absolute left-1/2 -translate-x-1/2 bottom-2 lg:bottom-2 xl:bottom-6 flex gap-5">
            <a
              href="https://www.tbdine.com/book/restaurant/the-farmhouse-restaurant?idApp=70973&language=en-us"
              rel="noreferrer"
              target="_blank"
              className={`text-xs lg:text-sm tracking-widest uppercase cursor-pointer bg-th-red text-white py-2 px-5 whitespace-nowrap transition-all hover:bg-white hover:text-th-red`}
            >
              book now
            </a>
          </div> */}
        </div>
        <div className="relative hidden md:inline-block px-4 m-auto">
          <a href="/groupbookings_form" rel="noreferrer" target="_blank">
            <img
              src={popup2}
              alt='"Host Less, Celebrate More" private events and holiday party inquiry popup for The Farmhouse'
              className="h-full object-contain"
            />
          </a>
          {/* <div className="absolute left-1/2 -translate-x-1/2 bottom-2 lg:bottom-5 xl:bottom-10 flex gap-5">
            <a
              href="https://www.tbdine.com/book/restaurant/the-farmhouse-restaurant?idApp=70973&language=en-us"
              rel="noreferrer"
              target="_blank"
              className="mb-0 lg:mb-1 font-primary opacity-0 lowercase text-lg cursor-pointer bg-transparent text-white px-20 py-6 rounded-md transition-all hover:bg-transparent hover:text-white flex justify-center items-center"
            >
              View Menu
            </a>
          </div> */}
        </div>
      </div>
      <div
        className={`${
          open ? "fixed" : "hidden"
        } w-screen h-screen overflow-x-hidden overflow-y-scroll bg-black/70 z-[1000] block md:hidden`}
        onClick={() => setOpen(false)}
      ></div>
      <div
        className={`${
          open ? "absolute" : "hidden"
        } w-5/6 max-w-[480px] h-auto md:max-w-[1200px] bg-transparent top-[20%] left-1/2 -translate-x-1/2 bg-[#EAE4DA] z-[1001]`}
      >
        <IoCloseSharp
          size={40}
          className="absolute md:hidden -right-5 lg:-right-14 -top-10 text-white cursor-pointer"
          onClick={() => setOpen(false)}
        />
        <div className="relative block md:hidden">
          {/* <img
            src={pop_mobile}
            alt="Father's Day brunch promotion popup for The Farmhouse featuring N'Duja and Fennel Sausage Hash and a Wildeye Pilsner pairing (mobile)"
            className="w-full h-full object-contain"
          />
          <div className="absolute  left-1/2 -translate-x-1/2 bottom-16 flex flex-col gap-2 text-center">
            <a
              href="https://www.tbdine.com/book/restaurant/the-farmhouse-restaurant?idApp=70973&language=en-us"
              rel="noreferrer"
              className={`tracking-widest uppercase text-md cursor-pointer bg-th-red text-white py-2 px-3 whitespace-nowrap transition-all hover:bg-white hover:text-th-red`}
            >
              book now
            </a>
          </div> */}
        </div>
        <div className="relative block md:hidden py-5">
          <a href="/groupbookings_form" rel="noreferrer" target="_blank">
            <img
              src={popup_mobile2}
              alt='"Host Less, Celebrate More" private events and holiday party inquiry popup for The Farmhouse (mobile)'
              className="w-full h-full object-contain"
            />
          </a>
          {/* <div className="absolute left-1/2 -translate-x-1/2 top-[80%] flex flex-col gap-2 text-center">
            <a
              href="https://www.tbdine.com/book/restaurant/the-farmhouse-restaurant?idApp=70973&language=en-us"
              rel="noreferrer"
              target="_blank"
              className="mb-0 lg:mb-1 font-primary opacity-0 lowercase text-lg cursor-pointer bg-black text-white px-6 py-1  rounded-md transition-all hover:bg-th-brown hover:text-white flex justify-center items-center"
            >
              View Menu
            </a>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Popup;
